import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bool_showApp: false,
    isFullOption: false,
    usilieSpec: 'dlinaSpec',
    selectedDirection: 'directRight',
    zacepType: 'zacep_middle',
    viewOver: 'hide',
    viewOverDirection: 'back',
    direction: 'vniz',
    measurement: 'Newton',
    measurement_txt: 'Н',
    activeLabel: '',
    a_remLabel: '',
    var_n: 15,
    var_n3: 1,
    var_p: 1,
    var_Dvn: 14, //''
    var_Dnar: 8, //''
    var_d: 1, //''
    var_l01: 120, //''
    var_l0: 160, //''
    var_l1: '', //''
    var_l2: '', //''
    var_l3: 190, //''
    var_s1: 2, //''
    var_s2: 12, //''
    var_s3: 22, //''
    var_f1: 0,
    var_f2: 0,
    var_f3: 0,
    var_f1_view: 0,
    var_f2_view: 0,
    var_f3_view: 0,
    var_i: 0,
    var_a: 0,
    calc_G: null,
    var_k: 9.81,
    var_z: 0,
    var_z_stiffness: null,
    var_tau3: 0,
    var_m: 1,
    var_total_m: 1,
    calc_D0: 0,
    kol_pruzhin: 1000,
    showOptionActive: false,
    active_el: 0,
    d_values: [
      [{
          'id': '1',
          value: '0.2',
          v_Newton: '1238.5'
        },
        {
          'id': '2',
          value: '0.25',
          v_Newton: '1238.5'
        },
        {
          'id': '3',
          value: '0.3',
          v_Newton: '1238.5'
        },
        {
          'id': '4',
          value: '0.36',
          v_Newton: '1214'
        },
        {
          'id': '5',
          value: '0.4',
          v_Newton: '1189.5'
        },
        {
          'id': '6',
          value: '0.5',
          v_Newton: '1189.5'
        },
        {
          'id': '7',
          value: '0.6',
          v_Newton: '1189.5'
        },
        {
          'id': '8',
          value: '0.63',
          v_Newton: '1177.2'
        },
        {
          'id': '9',
          value: '0.7',
          v_Newton: '1177.2'
        },
        {
          'id': '10',
          value: '0.75',
          v_Newton: '1164.9'
        },
        {
          'id': '11',
          value: '0.8',
          v_Newton: '1164.9'
        },
        {
          'id': '12',
          value: '0.9',
          v_Newton: '1152.7'
        },
        {
          'id': '13',
          value: '1',
          v_Newton: '1128.2'
        },
        {
          'id': '14',
          value: '1.1',
          v_Newton: '1103.6'
        },
        {
          'id': '15',
          value: '1.2',
          v_Newton: '1079.1'
        },
        {
          'id': '16',
          value: '1.3',
          v_Newton: '1066.8'
        },
        {
          'id': '17',
          value: '1.4',
          v_Newton: '1042.3'
        },
        {
          'id': '18',
          value: '1.5',
          v_Newton: '1017.8'
        },
        {
          'id': '19',
          value: '1.6',
          v_Newton: '1005.5'
        },
        {
          'id': '20',
          value: '1.7',
          v_Newton: '956.5'
        },
        {
          'id': '21',
          value: '1.8',
          v_Newton: '956.5'
        },
        {
          'id': '22',
          value: '1.9',
          v_Newton: '944.2'
        },
        {
          'id': '23',
          value: '2',
          v_Newton: '944.2'
        },
        {
          'id': '24',
          value: '2.1',
          v_Newton: '919.7'
        },
        {
          'id': '25',
          value: '2.2',
          v_Newton: '895.2'
        },
        {
          'id': '26',
          value: '2.3',
          v_Newton: '895.2'
        },
        {
          'id': '27',
          value: '2.5',
          v_Newton: '870.6'
        },
        {
          'id': '28',
          value: '2.8',
          v_Newton: '870.6'
        },
        {
          'id': '29',
          value: '3',
          v_Newton: '960'
        },
        {
          'id': '30',
          value: '3.2',
          v_Newton: '821.6'
        },
        {
          'id': '31',
          value: '3.5',
          v_Newton: '960'
        },
        {
          'id': '32',
          value: '3.6',
          v_Newton: '821.6'
        },
        {
          'id': '33',
          value: '3.75',
          v_Newton: '797.1'
        },
        {
          'id': '34',
          value: '4',
          v_Newton: '797.1'
        },
        {
          'id': '35',
          value: '4.5',
          v_Newton: '748'
        },
        {
          'id': '36',
          value: '5',
          v_Newton: '748'
        },
        {
          'id': '37',
          value: '5.5',
          v_Newton: '723.5'
        },
        {
          'id': '38',
          value: '6',
          v_Newton: '723.5'
        },
        {
          'id': '39',
          value: '6.5',
          v_Newton: '662.2'
        },
        {
          'id': '40',
          value: '7',
          v_Newton: '662.2'
        },
        {
          'id': '41',
          value: '7.5',
          v_Newton: '662.2'
        },
        {
          'id': '42',
          value: '8',
          v_Newton: '662.2'
        },
        {
          'id': '43',
          value: '8.5',
          v_Newton: '960'
        },
        {
          'id': '44',
          value: '9',
          v_Newton: '960'
        },
        {
          'id': '45',
          value: '10',
          v_Newton: '960'
        },
        {
          'id': '46',
          value: '11',
          v_Newton: '960'
        },
        {
          'id': '47',
          value: '12',
          v_Newton: '960'
        },
        {
          'id': '48',
          value: '13',
          v_Newton: '800'
        },
        {
          'id': '59',
          value: '14',
          v_Newton: '800'
        },
        {
          'id': '50',
          value: '15',
          v_Newton: '800'
        },
        {
          'id': '51',
          value: '16',
          v_Newton: '800'
        }
      ],
      [{
          'id': '1',
          value: '0.2',
          v_Newton: '1238,5'
        },
        {
          'id': '2',
          value: '0.25',
          v_Newton: '1238,5'
        },
        {
          'id': '3',
          value: '0.3',
          v_Newton: '1238,5'
        },
        {
          'id': '4',
          value: '0.36',
          v_Newton: '1214,0'
        },
        {
          'id': '5',
          value: '0.4',
          v_Newton: '1189,5'
        },
        {
          'id': '6',
          value: '0.5',
          v_Newton: '1189,5'
        },
        {
          'id': '7',
          value: '0.6',
          v_Newton: '1189,5'
        },
        {
          'id': '8',
          value: '0.63',
          v_Newton: '1177,2'
        },
        {
          'id': '9',
          value: '0.7',
          v_Newton: '1177,2'
        },
        {
          'id': '10',
          value: '0.75',
          v_Newton: '1164,9'
        },
        {
          'id': '11',
          value: '0.8',
          v_Newton: '1164,9'
        },
        {
          'id': '12',
          value: '0.9',
          v_Newton: '1152,7'
        },
        {
          'id': '13',
          value: '1',
          v_Newton: '1128,2'
        },
        {
          'id': '14',
          value: '1.1',
          v_Newton: '1103,6'
        },
        {
          'id': '15',
          value: '1.2',
          v_Newton: '1079,1'
        },
        {
          'id': '16',
          value: '1.3',
          v_Newton: '1066,8'
        },
        {
          'id': '17',
          value: '1.4',
          v_Newton: '1042,3'
        },
        {
          'id': '18',
          value: '1.5',
          v_Newton: '1017,8'
        },
        {
          'id': '19',
          value: '1.6',
          v_Newton: '1005,5'
        },
        {
          'id': '20',
          value: '1.7',
          v_Newton: '956,5'
        },
        {
          'id': '21',
          value: '1.8',
          v_Newton: '956,5'
        },
        {
          'id': '22',
          value: '1.9',
          v_Newton: '944,2'
        },
        {
          'id': '23',
          value: '2',
          v_Newton: '944,2'
        },
        {
          'id': '24',
          value: '2.1',
          v_Newton: '919,7'
        },
        {
          'id': '25',
          value: '2.2',
          v_Newton: '895,2'
        },
        {
          'id': '26',
          value: '2.3',
          v_Newton: '895,2'
        },
        {
          'id': '27',
          value: '2.5',
          v_Newton: '870,6'
        },
        {
          'id': '28',
          value: '2.8',
          v_Newton: '870,6'
        },
        {
          'id': '29',
          value: '3',
          v_Newton: '870,6'
        },
        {
          'id': '30',
          value: '3.2',
          v_Newton: '821,6'
        },
        {
          'id': '31',
          value: '3.5',
          v_Newton: '821,6'
        },
        {
          'id': '32',
          value: '3.6',
          v_Newton: '821,6'
        },
        {
          'id': '33',
          value: '3.75',
          v_Newton: '797,1'
        },
        {
          'id': '34',
          value: '4',
          v_Newton: '797,1'
        },
        {
          'id': '35',
          value: '4.5',
          v_Newton: '748,0'
        },
        {
          'id': '36',
          value: '5',
          v_Newton: '748,0'
        },
        {
          'id': '37',
          value: '5.5',
          v_Newton: '723,49'
        },
        {
          'id': '38',
          value: '6',
          v_Newton: '723,49'
        },
        {
          'id': '39',
          value: '6.5',
          v_Newton: '960.0'
        },
        {
          'id': '40',
          value: '7',
          v_Newton: '960.0'
        },
        {
          'id': '41',
          value: '7.5',
          v_Newton: '960.0'
        },
        {
          'id': '42',
          value: '8',
          v_Newton: '960.0'
        },
        {
          'id': '43',
          value: '8.5',
          v_Newton: '960.0'
        },
        {
          'id': '44',
          value: '9',
          v_Newton: '960.0'
        },
        {
          'id': '45',
          value: '10',
          v_Newton: '960.0'
        },
        {
          'id': '46',
          value: '11',
          v_Newton: '960.0'
        },
        {
          'id': '47',
          value: '12',
          v_Newton: '960.0'
        },
        {
          'id': '48',
          value: '13',
          v_Newton: '800'
        },
        {
          'id': '49',
          value: '14',
          v_Newton: '800'
        },
        {
          'id': '50',
          value: '15',
          v_Newton: '800'
        },
        {
          'id': '51',
          value: '16',
          v_Newton: '800'
        },
      ],
      [{
          'id': '1',
          value: '0.21',
          v_Newton: '932'
        },
        {
          'id': '2',
          value: '0.26',
          v_Newton: '932'
        },
        {
          'id': '3',
          value: '0.31',
          v_Newton: '932'
        },
        {
          'id': '4',
          value: '0.36',
          v_Newton: '932'
        },
        {
          'id': '5',
          value: '0.41',
          v_Newton: '932'
        },
        {
          'id': '6',
          value: '0.44',
          v_Newton: '932'
        },
        {
          'id': '7',
          value: '0.51',
          v_Newton: '932'
        },
        {
          'id': '8',
          value: '0.61',
          v_Newton: '932'
        },
        {
          'id': '9',
          value: '0.71',
          v_Newton: '932'
        },
        {
          'id': '10',
          value: '0.81',
          v_Newton: '932'
        },
        {
          'id': '11',
          value: '0.91',
          v_Newton: '932'
        },
        {
          'id': '12',
          value: '1.01',
          v_Newton: '932'
        },
        {
          'id': '13',
          value: '1.11',
          v_Newton: '932'
        },
        {
          'id': '14',
          value: '1.21',
          v_Newton: '932'
        },
        {
          'id': '15',
          value: '1.31',
          v_Newton: '932'
        },
        {
          'id': '16',
          value: '1.41',
          v_Newton: '932'
        },
        {
          'id': '17',
          value: '1.51',
          v_Newton: '932'
        },
        {
          'id': '18',
          value: '1.61',
          v_Newton: '932'
        },
        {
          'id': '19',
          value: '1.81',
          v_Newton: '932'
        },
        {
          'id': '20',
          value: '2.01',
          v_Newton: '932'
        },
        {
          'id': '21',
          value: '2.21',
          v_Newton: '932'
        },
        {
          'id': '22',
          value: '2.51',
          v_Newton: '932'
        },
        {
          'id': '23',
          value: '2.81',
          v_Newton: '932'
        },
        {
          'id': '24',
          value: '3.01',
          v_Newton: '907.4'
        },
        {
          'id': '25',
          value: '3.21',
          v_Newton: '907.4'
        },
        {
          'id': '26',
          value: '3.51',
          v_Newton: '907.4'
        },
        {
          'id': '27',
          value: '4.01',
          v_Newton: '882.9'
        },
        {
          'id': '28',
          value: '4.51',
          v_Newton: '870.6'
        },
        {
          'id': '29',
          value: '5.01',
          v_Newton: '833.9'
        },
        {
          'id': '30',
          value: '5.51',
          v_Newton: '833.9'
        },
        {
          'id': '31',
          value: '6.01',
          v_Newton: '809.3'
        },
        {
          'id': '32',
          value: '6.51',
          v_Newton: '760.3'
        },
        {
          'id': '33',
          value: '7.01',
          v_Newton: '760.3'
        },
        {
          'id': '34',
          value: '8.01',
          v_Newton: '735.8'
        },
        {
          'id': '35',
          value: '9.01',
          v_Newton: '613.1'
        },
        {
          'id': '36',
          value: '10.01',
          v_Newton: '613.1'
        },
      ],
      [{
          'id': '1',
          value: '1',
          v_Newton: '995.8'
        },
        {
          'id': '2',
          value: '1.2',
          v_Newton: '995.8'
        },
        {
          'id': '3',
          value: '1.4',
          v_Newton: '969.8'
        },
        {
          'id': '4',
          value: '1.5',
          v_Newton: '969.8'
        },
        {
          'id': '5',
          value: '1.6',
          v_Newton: '969.8'
        },
        {
          'id': '6',
          value: '1.8',
          v_Newton: '960'
        },
        {
          'id': '7',
          value: '2',
          v_Newton: '960'
        },
        {
          'id': '8',
          value: '2.2',
          v_Newton: '960'
        },
        {
          'id': '9',
          value: '2.5',
          v_Newton: '960'
        },
        {
          'id': '10',
          value: '3',
          v_Newton: '960'
        },
        {
          'id': '11',
          value: '3.5',
          v_Newton: '960'
        },
        {
          'id': '12',
          value: '4',
          v_Newton: '960'
        },
        {
          'id': '13',
          value: '4.5',
          v_Newton: '960'
        },
        {
          'id': '14',
          value: '5',
          v_Newton: '960'
        },
        {
          'id': '15',
          value: '5.5',
          v_Newton: '960'
        },
        {
          'id': '16',
          value: '6',
          v_Newton: '960'
        },
        {
          'id': '17',
          value: '6.5',
          v_Newton: '960'
        },
        {
          'id': '18',
          value: '7',
          v_Newton: '960'
        },
        {
          'id': '19',
          value: '7.5',
          v_Newton: '960'
        },
        {
          'id': '20',
          value: '8',
          v_Newton: '960'
        },
        {
          'id': '21',
          value: '8.5',
          v_Newton: '960'
        },
        {
          'id': '22',
          value: '9',
          v_Newton: '960'
        },
        {
          'id': '23',
          value: '10',
          v_Newton: '960'
        },
        {
          'id': '24',
          value: '11',
          v_Newton: '960'
        },
        {
          'id': '25',
          value: '12',
          v_Newton: '960'
        },
        {
          'id': '26',
          value: '13',
          v_Newton: '800'
        },
        {
          'id': '27',
          value: '14',
          v_Newton: '800'
        },
        {
          'id': '28',
          value: '15',
          v_Newton: '800'
        },
        {
          'id': '29',
          value: '16',
          v_Newton: '800'
        },
      ],
      [{
          'id': '1',
          value: '0.15',
          v_Newton: '441.5'
        },
        {
          'id': '2',
          value: '0.2',
          v_Newton: '441.5'
        },
        {
          'id': '3',
          value: '0.25',
          v_Newton: '441.5'
        },
        {
          'id': '4',
          value: '0.3',
          v_Newton: '441.5'
        },
        {
          'id': '5',
          value: '0.5',
          v_Newton: '441.5'
        },
        {
          'id': '6',
          value: '0.6',
          v_Newton: '441.5'
        },
        {
          'id': '7',
          value: '0.8',
          v_Newton: '441.5'
        },
        {
          'id': '8',
          value: '0.1',
          v_Newton: '441.5'
        },
        {
          'id': '9',
          value: '1.2',
          v_Newton: '441.5'
        },
        {
          'id': '10',
          value: '1.3',
          v_Newton: '441.5'
        },
        {
          'id': '11',
          value: '1.4',
          v_Newton: '441.5'
        },
        {
          'id': '12',
          value: '1.5',
          v_Newton: '441.5'
        },
        {
          'id': '13',
          value: '1.6',
          v_Newton: '441.5'
        },
        {
          'id': '14',
          value: '1.8',
          v_Newton: '441.5'
        },
        {
          'id': '15',
          value: '2',
          v_Newton: '441.5'
        },
        {
          'id': '16',
          value: '2.5',
          v_Newton: '441.5'
        },
        {
          'id': '17',
          value: '3',
          v_Newton: '416.9'
        },
        {
          'id': '18',
          value: '3.5',
          v_Newton: '416.9'
        },
        {
          'id': '19',
          value: '4',
          v_Newton: '416.9'
        },
        {
          'id': '20',
          value: '4.5',
          v_Newton: '407.1'
        },
        {
          'id': '21',
          value: '5',
          v_Newton: '407.1'
        },
        {
          'id': '22',
          value: '5.5',
          v_Newton: '407.1'
        },
        {
          'id': '23',
          value: '6',
          v_Newton: '407.1'
        },
        {
          'id': '24',
          value: '7',
          v_Newton: '407.1'
        },
      ],
      [{
          'id': '1',
          value: '0.3',
          v_Newton: '613.1'
        },
        {
          'id': '2',
          value: '0.4',
          v_Newton: '613.1'
        },
        {
          'id': '3',
          value: '0.5',
          v_Newton: '613.1'
        },
        {
          'id': '4',
          value: '0.6',
          v_Newton: '613.1'
        },
        {
          'id': '5',
          value: '0.7',
          v_Newton: '613.1'
        },
        {
          'id': '6',
          value: '0.8',
          v_Newton: '613.1'
        },
        {
          'id': '7',
          value: '0.9',
          v_Newton: '613.1'
        },
        {
          'id': '8',
          value: '1',
          v_Newton: '613.1'
        },
        {
          'id': '9',
          value: '1.1',
          v_Newton: '613.1'
        },
        {
          'id': '10',
          value: '1.2',
          v_Newton: '613.1'
        },
        {
          'id': '11',
          value: '1.3',
          v_Newton: '613.1'
        },
        {
          'id': '12',
          value: '1.4',
          v_Newton: '613.1'
        },
        {
          'id': '13',
          value: '1.5',
          v_Newton: '613.1'
        },
        {
          'id': '14',
          value: '1.6',
          v_Newton: '613.1'
        },
        {
          'id': '15',
          value: '1.8',
          v_Newton: '613.1'
        },
        {
          'id': '16',
          value: '1.9',
          v_Newton: '613.1'
        },
        {
          'id': '17',
          value: '2',
          v_Newton: '613.1'
        },
        {
          'id': '18',
          value: '2.1',
          v_Newton: '613.1'
        },
        {
          'id': '19',
          value: '2.2',
          v_Newton: '613.1'
        },
        {
          'id': '20',
          value: '2.3',
          v_Newton: '613.1'
        },
        {
          'id': '21',
          value: '2.5',
          v_Newton: '613.1'
        },
        {
          'id': '22',
          value: '2.8',
          v_Newton: '613.1'
        },
        {
          'id': '23',
          value: '3',
          v_Newton: '613.1'
        },
        {
          'id': '24',
          value: '3.2',
          v_Newton: '613.1'
        },
        {
          'id': '25',
          value: '3.5',
          v_Newton: '613.1'
        },
        {
          'id': '26',
          value: '3.6',
          v_Newton: '613.1'
        },
        {
          'id': '27',
          value: '3.75',
          v_Newton: '613.1'
        },
        {
          'id': '28',
          value: '4',
          v_Newton: '613.1'
        },
        {
          'id': '29',
          value: '4.5',
          v_Newton: '613.1'
        },
        {
          'id': '30',
          value: '5',
          v_Newton: '613.1'
        },
        {
          'id': '31',
          value: '5.5',
          v_Newton: '613.1'
        },
        {
          'id': '32',
          value: '6',
          v_Newton: '613.1'
        },
        {
          'id': '33',
          value: '6.5',
          v_Newton: '613.1'
        },
        {
          'id': '34',
          value: '7',
          v_Newton: '613.1'
        },
        {
          'id': '35',
          value: '7.5',
          v_Newton: '613.1'
        },
        {
          'id': '36',
          value: '8',
          v_Newton: '613.1'
        },
      ],
      [{
          'id': '1',
          value: '0.3',
          v_Newton: '490.5'
        },
        {
          'id': '2',
          value: '0.4',
          v_Newton: '490.5'
        },
        {
          'id': '3',
          value: '0.5',
          v_Newton: '490.5'
        },
        {
          'id': '4',
          value: '0.6',
          v_Newton: '490.5'
        },
        {
          'id': '5',
          value: '0.7',
          v_Newton: '490.5'
        },
        {
          'id': '6',
          value: '0.8',
          v_Newton: '490.5'
        },
        {
          'id': '7',
          value: '0.9',
          v_Newton: '490.5'
        },
        {
          'id': '8',
          value: '1',
          v_Newton: '490.5'
        },
        {
          'id': '9',
          value: '1.1',
          v_Newton: '466'
        },
        {
          'id': '10',
          value: '1.2',
          v_Newton: '466'
        },
        {
          'id': '11',
          value: '1.3',
          v_Newton: '466'
        },
        {
          'id': '12',
          value: '1.4',
          v_Newton: '466'
        },
        {
          'id': '13',
          value: '1.5',
          v_Newton: '466'
        },
        {
          'id': '14',
          value: '1.6',
          v_Newton: '466'
        },
        {
          'id': '15',
          value: '1.8',
          v_Newton: '466'
        },
        {
          'id': '16',
          value: '1.9',
          v_Newton: '466'
        },
        {
          'id': '17',
          value: '2',
          v_Newton: '466'
        },
        {
          'id': '18',
          value: '2.1',
          v_Newton: '466'
        },
        {
          'id': '19',
          value: '2.2',
          v_Newton: '466'
        },
        {
          'id': '20',
          value: '2.3',
          v_Newton: '466'
        },
        {
          'id': '21',
          value: '2.5',
          v_Newton: '466'
        },
        {
          'id': '22',
          value: '2.8',
          v_Newton: '466'
        },
        {
          'id': '23',
          value: '3',
          v_Newton: '466'
        },
        {
          'id': '24',
          value: '3.2',
          v_Newton: '466'
        },
        {
          'id': '25',
          value: '3.5',
          v_Newton: '466'
        },
        {
          'id': '26',
          value: '3.6',
          v_Newton: '466'
        },
        {
          'id': '27',
          value: '3.75',
          v_Newton: '466'
        },
        {
          'id': '28',
          value: '4',
          v_Newton: '466'
        },
        {
          'id': '29',
          value: '4.5',
          v_Newton: '466'
        },
        {
          'id': '30',
          value: '5',
          v_Newton: '466'
        },
        {
          'id': '31',
          value: '5.5',
          v_Newton: '466'
        },
        {
          'id': '32',
          value: '6',
          v_Newton: '466'
        },
        {
          'id': '33',
          value: '6.5',
          v_Newton: '466'
        },
        {
          'id': '34',
          value: '7',
          v_Newton: '466'
        },
        {
          'id': '35',
          value: '7.5',
          v_Newton: '466'
        },
        {
          'id': '36',
          value: '8',
          v_Newton: '466'
        },
        {
          'id': '37',
          value: '9',
          v_Newton: '441.5'
        },
        {
          'id': '38',
          value: '10',
          v_Newton: '441.5'
        },
        {
          'id': '39',
          value: '11',
          v_Newton: '392.4'
        },
        {
          'id': '40',
          value: '12',
          v_Newton: '392.4'
        },
      ],
      [{
          'id': '1',
          value: '0.2',
          v_Newton: '1238.5'
        },
        {
          'id': '2',
          value: '0.25',
          v_Newton: '1238.5'
        },
        {
          'id': '3',
          value: '0.3',
          v_Newton: '1238.5'
        },
        {
          'id': '4',
          value: '0.36',
          v_Newton: '1214'
        },
        {
          'id': '5',
          value: '0.4',
          v_Newton: '1189.5'
        },
        {
          'id': '6',
          value: '0.5',
          v_Newton: '1189.5'
        },
        {
          'id': '7',
          value: '0.6',
          v_Newton: '1189.5'
        },
        {
          'id': '8',
          value: '0.63',
          v_Newton: '1177.2'
        },
        {
          'id': '9',
          value: '0.7',
          v_Newton: '1177.2'
        },
        {
          'id': '10',
          value: '0.75',
          v_Newton: '1164.9'
        },
        {
          'id': '11',
          value: '0.8',
          v_Newton: '1164.9'
        },
        {
          'id': '12',
          value: '0.9',
          v_Newton: '1152.7'
        },
        {
          'id': '13',
          value: '1',
          v_Newton: '1128.2'
        },
        {
          'id': '14',
          value: '1.1',
          v_Newton: '1103.6'
        },
        {
          'id': '15',
          value: '1.2',
          v_Newton: '1079.1'
        },
        {
          'id': '16',
          value: '1.3',
          v_Newton: '1066.8'
        },
        {
          'id': '17',
          value: '1.4',
          v_Newton: '1042.3'
        },
        {
          'id': '18',
          value: '1.5',
          v_Newton: '1017.8'
        },
        {
          'id': '19',
          value: '1.6',
          v_Newton: '1005.5'
        },
        {
          'id': '20',
          value: '1.7',
          v_Newton: '956.5'
        },
        {
          'id': '21',
          value: '1.8',
          v_Newton: '956.5'
        },
        {
          'id': '22',
          value: '1.9',
          v_Newton: '944.2'
        },
        {
          'id': '23',
          value: '2',
          v_Newton: '944.2'
        },
        {
          'id': '24',
          value: '2.1',
          v_Newton: '919.7'
        },
        {
          'id': '25',
          value: '2.2',
          v_Newton: '895.2'
        },
        {
          'id': '26',
          value: '2.3',
          v_Newton: '895.2'
        },
        {
          'id': '27',
          value: '2.5',
          v_Newton: '870.6'
        },
        {
          'id': '28',
          value: '2.8',
          v_Newton: '870.6'
        },
        {
          'id': '29',
          value: '3',
          v_Newton: '870.6'
        },
        {
          'id': '30',
          value: '3.2',
          v_Newton: '821.6'
        },
        {
          'id': '31',
          value: '3.5',
          v_Newton: '821.6'
        },
        {
          'id': '32',
          value: '3.6',
          v_Newton: '821.6'
        },
        {
          'id': '33',
          value: '3.75',
          v_Newton: '797.1'
        },
        {
          'id': '34',
          value: '4',
          v_Newton: '797.1'
        },
        {
          'id': '35',
          value: '4.5',
          v_Newton: '748'
        },
        {
          'id': '36',
          value: '5',
          v_Newton: '748'
        },
        {
          'id': '37',
          value: '5.5',
          v_Newton: '723.49'
        },
        {
          'id': '38',
          value: '6',
          v_Newton: '723.49'
        },
        {
          'id': '39',
          value: '7',
          v_Newton: '662.18'
        },
        {
          'id': '40',
          value: '8',
          v_Newton: '662.18'
        },
        {
          'id': '41',
          value: '9',
          v_Newton: '960'
        },
        {
          'id': '42',
          value: '10',
          v_Newton: '960'
        },
        {
          'id': '43',
          value: '11',
          v_Newton: '960'
        },
        {
          'id': '44',
          value: '12',
          v_Newton: '960'
        },
        {
          'id': '45',
          value: '13',
          v_Newton: '800'
        },
        {
          'id': '46',
          value: '14',
          v_Newton: '800'
        },
        {
          'id': '47',
          value: '15',
          v_Newton: '800'
        },
        {
          'id': '48',
          value: '16',
          v_Newton: '800'
        },
      ],
      [{
          'id': '1',
          value: '1',
          v_Newton: '995.8'
        },
        {
          'id': '2',
          value: '1.2',
          v_Newton: '995.8'
        },
        {
          'id': '3',
          value: '1.4',
          v_Newton: '969.8'
        },
        {
          'id': '4',
          value: '1.5',
          v_Newton: '969.8'
        },
        {
          'id': '5',
          value: '1.6',
          v_Newton: '969.8'
        },
        {
          'id': '6',
          value: '1.8',
          v_Newton: '960'
        },
        {
          'id': '7',
          value: '2',
          v_Newton: '960'
        },
        {
          'id': '8',
          value: '2.2',
          v_Newton: '960'
        },
        {
          'id': '9',
          value: '2.5',
          v_Newton: '960'
        },
        {
          'id': '10',
          value: '3',
          v_Newton: '960'
        },
        {
          'id': '11',
          value: '3.5',
          v_Newton: '960'
        },
        {
          'id': '12',
          value: '4',
          v_Newton: '960'
        },
        {
          'id': '13',
          value: '4.5',
          v_Newton: '960'
        },
        {
          'id': '14',
          value: '5',
          v_Newton: '960'
        },
        {
          'id': '15',
          value: '5.5',
          v_Newton: '960'
        },
        {
          'id': '16',
          value: '6',
          v_Newton: '960'
        },
        {
          'id': '17',
          value: '6.5',
          v_Newton: '960'
        },
        {
          'id': '18',
          value: '7',
          v_Newton: '960'
        },
        {
          'id': '19',
          value: '7.5',
          v_Newton: '960'
        },
        {
          'id': '20',
          value: '8',
          v_Newton: '960'
        },
        {
          'id': '21',
          value: '8.5',
          v_Newton: '960'
        },
        {
          'id': '22',
          value: '9',
          v_Newton: '960'
        },
        {
          'id': '23',
          value: '10',
          v_Newton: '960'
        },
        {
          'id': '24',
          value: '11',
          v_Newton: '960'
        },
        {
          'id': '25',
          value: '12',
          v_Newton: '960'
        },
        {
          'id': '26',
          value: '13',
          v_Newton: '800'
        },
        {
          'id': '27',
          value: '14',
          v_Newton: '800'
        },
        {
          'id': '28',
          value: '15',
          v_Newton: '800'
        },
        {
          'id': '29',
          value: '16',
          v_Newton: '800'
        },
      ],
      [{
          'id': '1',
          value: '0.2',
          v_Newton: '932'
        },
        {
          'id': '2',
          value: '0.25',
          v_Newton: '932'
        },
        {
          'id': '3',
          value: '0.3',
          v_Newton: '932'
        },
        {
          'id': '4',
          value: '0.35',
          v_Newton: '932'
        },
        {
          'id': '5',
          value: '0.4',
          v_Newton: '932'
        },
        {
          'id': '6',
          value: '0.44',
          v_Newton: '932'
        },
        {
          'id': '7',
          value: '0.5',
          v_Newton: '932'
        },
        {
          'id': '8',
          value: '0.6',
          v_Newton: '932'
        },
        {
          'id': '9',
          value: '0.7',
          v_Newton: '932'
        },
        {
          'id': '10',
          value: '0.8',
          v_Newton: '932'
        },
        {
          'id': '11',
          value: '0.9',
          v_Newton: '932'
        },
        {
          'id': '12',
          value: '1',
          v_Newton: '932'
        },
        {
          'id': '13',
          value: '1.1',
          v_Newton: '932'
        },
        {
          'id': '14',
          value: '1.2',
          v_Newton: '932'
        },
        {
          'id': '15',
          value: '1.3',
          v_Newton: '932'
        },
        {
          'id': '16',
          value: '1.4',
          v_Newton: '932'
        },
        {
          'id': '17',
          value: '1.5',
          v_Newton: '932'
        },
        {
          'id': '18',
          value: '1.6',
          v_Newton: '932'
        },
        {
          'id': '19',
          value: '1.8',
          v_Newton: '932'
        },
        {
          'id': '20',
          value: '2',
          v_Newton: '932'
        },
        {
          'id': '21',
          value: '2.2',
          v_Newton: '932'
        },
        {
          'id': '22',
          value: '2.5',
          v_Newton: '932'
        },
        {
          'id': '23',
          value: '2.8',
          v_Newton: '932'
        },
        {
          'id': '24',
          value: '3',
          v_Newton: '907.4'
        },
        {
          'id': '25',
          value: '3.2',
          v_Newton: '907.4'
        },
        {
          'id': '26',
          value: '3.5',
          v_Newton: '907.4'
        },
        {
          'id': '27',
          value: '4',
          v_Newton: '882.9'
        },
        {
          'id': '28',
          value: '4.5',
          v_Newton: '870.6'
        },
        {
          'id': '29',
          value: '5',
          v_Newton: '833.9'
        },
        {
          'id': '30',
          value: '5.5',
          v_Newton: '833.9'
        },
        {
          'id': '31',
          value: '6',
          v_Newton: '809.3'
        },
        {
          'id': '32',
          value: '6.5',
          v_Newton: '760.3'
        },
        {
          'id': '33',
          value: '7',
          v_Newton: '760.3'
        },
        {
          'id': '34',
          value: '8',
          v_Newton: '735.8'
        },
        {
          'id': '35',
          value: '9',
          v_Newton: '613.1'
        },
        {
          'id': '36',
          value: '10',
          v_Newton: '613.1'
        },
      ],
    ],
    material_list: [{
        'id': '1',
        value: 'Стандартная пружинная сталь',
        v_G: 8000,
        v_r: 7.85
      },
      {
        'id': '2',
        value: 'Проволока по ГОСТ 9389',
        v_G: 8000,
        v_r: 7.85
      },
      {
        'id': '3',
        value: 'Проволока 12Х18Н10Т',
        v_G: 7000,
        v_r: 7.9
      },
      {
        'id': '4',
        value: '60С2А, 51ХФА',
        v_G: 8000,
        v_r: 7.85
      },
      {
        'id': '5',
        value: 'Бронза БркМЦ3-1',
        v_G: 4000,
        v_r: 8.47
      },
      {
        'id': '6',
        value: 'ХН77ТЮР (ЭИ437Б)',
        v_G: 8000,
        v_r: 7.85
      },
      {
        'id': '7',
        value: 'Титановый сплав ВТ16, ТС6',
        v_G: 4000,
        v_r: 8.47
      },
      {
        'id': '8',
        value: 'Проволока по ЕN 10270-1',
        v_G: 8307.85,
        v_r: 7.85
      },
      {
        'id': '9',
        value: 'Проволока по ЕN 10270-2',
        v_G: 8104,
        v_r: 7.85
      },
      {
        'id': '10',
        value: 'Проволока по ЕN 10270-3',
        v_G: 7135.6,
        v_r: 7.9
      },
      // { 'id': '11', value: 'Нестандартный материал', v_G: 8000, v_r: 7.85 }
    ],
    selected: 1,
    selected_cover: 1,
    cover_list: [{
        'id': '1',
        value: 'Без покрытия'
      },
      {
        'id': '2',
        value: 'Хим.Фос.прм.'
      },
      {
        'id': '3',
        value: 'Хим.Окс.прм.'
      },
      {
        'id': '4',
        value: 'Хим.Фос/лак'
      },
      {
        'id': '5',
        value: 'Цинкование (Ц6…30.хр)'
      },
      {
        'id': '6',
        value: 'Кадмирование (Кд6…30.хр)'
      },
      {
        'id': '7',
        value: 'Никелерование (Н6…30)'
      },
      {
        'id': '8',
        value: 'Другое'
      },
    ],
    direction_list: [{
        'id': 'default',
        value: 'Любое',
        'class': 'default'
      },
      {
        'id': 'directRight',
        value: 'Правое',
        'class': 'right'
      },
      {
        'id': 'directLeft',
        value: 'Левое',
        'class': 'left'
      },
    ],
    selected_direction: 1,
    vvod_n: false,
    checkEmpty: false,
    is_emptyInput: false,
    small: false,
    show_ref: false,
    result_n: '',
    ref_variable_list: [{
        variable: 'd',
        text: 'диаметр проволоки, ',
        measurement: 'мм'
      },
      {
        variable: 'D<sub>нар</sub>',
        text: 'наружный  диаметр, ',
        measurement: 'мм'
      },
      {
        variable: 'D<sub>вн</sub>',
        text: 'внутренний диаметр, ',
        measurement: 'мм'
      },
      {
        variable: 'l<sub>0</sub>',
        text: 'длина пружины по зацепам, ',
        measurement: 'мм'
      },
      {
        variable: "l<sub>0'</sub>",
        text: 'длина пружины по телу, ',
        measurement: 'мм'
      },
      {
        variable: 'l<sub>1</sub>',
        text: 'предварительное растяжение, ',
        measurement: 'мм'
      },
      {
        variable: 'l<sub>2</sub>',
        text: 'рабочее растяжение, ',
        measurement: 'мм'
      },
      {
        variable: 'l<sub>3</sub>',
        text: 'максимальное растяжение, ',
        measurement: 'мм'
      },
      {
        variable: 'S<sub>1</sub>',
        text: 'предварительное растяжение, ',
        measurement: 'мм'
      },
      {
        variable: 'S<sub>2</sub>',
        text: 'рабочее растяжение,',
        measurement: ' мм'
      },
      {
        variable: 'S<sub>3</sub>',
        text: 'максимальное растяжение, ',
        measurement: 'мм'
      },
      {
        variable: 'F<sub>1</sub>',
        text: 'предварительная нагрузка, ',
        measurement: 'Н'
      },
      {
        variable: 'F<sub>2</sub>',
        text: 'рабочая нагрузка, ',
        measurement: 'Н'
      },
      {
        variable: 'F<sub>3</sub>',
        text: 'максимальная нагрузка, ',
        measurement: 'Н'
      },
    ],
    diameter_type: 'Dvn',
  },
  mutations: {
    func_input_replace(state) {
      // setTimeout(() => {
      state.var_f1_view = String(state.var_f1_view).replace(',', '.');
      state.var_f2_view = String(state.var_f2_view).replace(',', '.');
      state.var_f3_view = String(state.var_f3_view).replace(',', '.');
      state.var_l3 = String(state.var_l3).replace(',', '.');
      state.var_l2 = String(state.var_l2).replace(',', '.');
      state.var_l1 = String(state.var_l1).replace(',', '.');
      state.var_l01 = String(state.var_l01).replace(',', '.');
      state.var_l0 = String(state.var_l0).replace(',', '.');
      state.var_Dvn = String(state.var_Dvn).replace(',', '.');
      state.var_Dnar = String(state.var_Dnar).replace(',', '.');
      state.var_d = String(state.var_d).replace(',', '.');
      state.var_n = String(state.var_n).replace(',', '.');
      state.kol_pruzhin = String(state.kol_pruzhin).replace(',', '.');
      state.var_s1 = String(state.var_s1).replace(',', '.');
      state.var_s2 = String(state.var_s2).replace(',', '.');
      state.var_s3 = String(state.var_s3).replace(',', '.');
      console.log('1var_n = ' + state.var_n);
      if (state.var_Dvn && state.var_Dnar && state.var_d && state.var_l3 && state.var_l0 && state.var_l01 && state.var_n && state.kol_pruzhin) {
        state.checkEmpty = false;
        state.is_emptyInput = false;
        console.log('state.is_emptyInput = ' + state.is_emptyInput);
      } else {
        state.checkEmpty = true;
        state.is_emptyInput = true;
        console.log('state.is_emptyInput = ' + state.is_emptyInput);
      }
      // }, 10);
    },
    func_output_replace(state) {
      // setTimeout(() => {
      state.var_f1_view = String(state.var_f1_view).replace('.', ',');
      state.var_f2_view = String(state.var_f2_view).replace('.', ',');
      state.var_f3_view = String(state.var_f3_view).replace('.', ',');
      state.var_l3 = String(state.var_l3).replace('.', ',');
      state.var_l2 = String(state.var_l2).replace('.', ',');
      state.var_l1 = String(state.var_l1).replace('.', ',');
      state.var_l01 = String(state.var_l01).replace('.', ',');
      state.var_l0 = String(state.var_l0).replace('.', ',');
      state.var_Dvn = String(state.var_Dvn).replace('.', ',');
      state.var_Dnar = String(state.var_Dnar).replace('.', ',');
      state.var_d = String(state.var_d).replace('.', ',');
      state.var_n = String(state.var_n).replace('.', ',');
      state.kol_pruzhin = String(state.kol_pruzhin).replace('.', ',');
      state.var_s1 = String(state.var_s1).replace('.', ',');
      state.var_s2 = String(state.var_s2).replace('.', ',');
      state.var_s3 = String(state.var_s3).replace('.', ',');
      state.var_i = String(state.var_i).replace('.', ',');
      state.var_a = String(state.var_a).replace('.', ',');
      state.var_z_stiffness = String(state.var_z_stiffness).replace('.', ',');
      state.var_tau3 = String(state.var_tau3).replace('.', ',');
      state.var_m = String(state.var_m).replace('.', ',');
      state.var_total_m = String(state.var_total_m).replace('.', ',');
      // }, 50);
    },
    showApp(state) {
      setTimeout(() => {
        state.bool_showApp = true
      }, 1500);
      console.log('Сработал прелоадер');
    },
    basicState(state) {
      state.usilieSpec = 'dlinaSpec';
      state.selectedDirection = 'directRight';
      state.zacepType = 'zacep_middle';
      state.viewOver = 'hide';
    },
    direction(state) {
      if (!state.checkEmpty) {
        var integer_n;
         console.log('state.var_n = ' + state.var_n);
         console.log('state.var_n % 1 = ' + state.var_n % 1);
         console.log('state.var_n % 1 == 0.75 = ');
         console.log(state.var_n % 1 == 0.75);
        if (state.var_n % 1 == 0.75) {
          console.log('state.var_n = ' + state.var_n);
          integer_n = parseFloat(state.var_n) + 0.25;
          console.log('state.var_n + 0.25 = ' + state.var_n);
        } else {
          integer_n = Math.trunc(state.var_n);
        }
        console.log('2 state.var_n = ' + state.var_n);
        var arr_1 = [integer_n, integer_n + 0.25, integer_n + 0.5, integer_n - 0.25, integer_n];
        var arr = [integer_n, integer_n + 0.25, integer_n + 0.5, integer_n - 0.25, integer_n];
        console.log('arr = ' + arr);
        var start;
        if (!state.vvod_n) {
          start = parseFloat(state.var_n) + 0.25;
        } else {
          start = parseFloat(state.var_n);
        }
        var end = integer_n + 0.75;
        console.log('start = ' + start + ' end = ' + end);
        var b;
        // var result_n;
        if (start < end) {
          if (!state.vvod_n) {
            state.var_n = parseFloat(state.var_n) + 0.25;
          }
          b = state.var_n;
          console.log('b1 = ' + b);
          state.result_n = arr.sort((x, y) => Math.abs(b - x) - Math.abs(b - y))[0];
          console.log(arr.sort((x, y) => Math.abs(b - x) - Math.abs(b - y))[0]);
        } else {
          state.var_n = Math.trunc(state.var_n) - 0.25;
          b = state.var_n;
          console.log('b2 = ' + b);
          state.result_n = arr.sort((x, y) => Math.abs(b - x) - Math.abs(b - y))[0];
          console.log(arr.sort((x, y) => Math.abs(b - x) - Math.abs(b - y))[0]);
        }

        switch (state.result_n) {
          case arr_1[0]:
            state.direction = 'vniz';
            state.viewOverDirection = 'back';
            console.log('0!!');
            break;
          case arr_1[1]:
            state.direction = 'back';
            state.viewOverDirection = 'verh';
            console.log('1!!')
            break;
          case arr_1[2]:
            state.direction = 'verh';
            state.viewOverDirection = 'front';
            console.log('2!!')
            break;
          case arr_1[3]:
            state.direction = 'front';
            state.viewOverDirection = 'vniz';
            console.log('3!!')
            break;
          case arr_1[4]:
            state.direction = 'vniz';
            state.viewOverDirection = 'back';
            console.log('4!!')
            break;

          default:
            state.direction = 'vniz';
            state.viewOverDirection = 'back';
            console.log('EERRROORR!!')
            break;
        }
        state.var_n = state.result_n;
      }
    },
    calc_Newton(state) {
      setTimeout(() => {
        state.measurement_txt = 'H';
        state.var_z_stiffness = Math.round(state.var_z * 100) / 100 + ' Н/мм';
      }, 1);
    },
    calc_kilo(state) {
      setTimeout(() => {
        state.measurement_txt = 'кг';
        state.var_z_stiffness = Math.round((state.var_z * 0.101972) * 100) / 100 + ' кг/мм';
      }, 1);
    },
    showOptionD(state) {
      state.showOptionActive = !state.showOptionActive;
    },
    hideOptionD(state) {
      setTimeout(() => {
        state.showOptionActive = false;
      }, 250);
    },
    turnType(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        switch (state.zacepType) {
          case 'zacep_middle':
            state.var_n3 = 1;
            state.var_p = 1;
            state.zacepType = 'zacep_middle';
            // console.log('n3=' + state.var_n3);
            // console.log('p=' + state.var_p);
            break;
          case 'zacep_short':
            state.var_n3 = 1; //0.5
            state.var_p = 1; //1
            state.zacepType = 'zacep_short';
            // console.log('n3=' + state.var_n3);
            // console.log('p=' + state.var_p);
            break;
          case 'zacep_long':
            state.var_n3 = 1; //1
            state.var_p = 1; //0
            state.zacepType = 'zacep_long';
            // console.log('n3=' + state.var_n3);
            // console.log('p=' + state.var_p);
            break;
          default:
            alert("Ошибка!");
        }
        // }, 50);
      }
    },
    func_resize() {
      var resizable = function(el, factor) {
        if (el != null) {
          var int = Number(factor) || 7.7;
          var resize;
          resize = function () {
            if (el.value.length <= 1) {
              el.style.width = '19px';
            } else if (el.value.length == 2) {
              el.style.width = '29px';
            } else {
              if (el.value.match(/[,.]/)) {
                el.style.width = ((el.value.length) * int) - 6 + 'px';
              } else {
                el.style.width = ((el.value.length) * int) + 2 + 'px';
              }
            }
          }
          var e = 'keyup,keypress,focus,blur,change'.split(',');
          for (var i in e) {
            if (el != null) {
              el.addEventListener(e[i], resize, false);
            }
          }
          resize();
        }
      }
      setTimeout(() => {
        resizable(document.getElementById('input_l3'), 13);
        resizable(document.getElementById('input_l2'), 13);
        resizable(document.getElementById('input_l1'), 13);
        resizable(document.getElementById('input_l0'), 13);
        resizable(document.getElementById('input_l01'), 13);
        resizable(document.getElementById('input_Dvn'), 13);
        resizable(document.getElementById('input_Dnar'), 13);
        resizable(document.getElementById('input_d'), 14);
        // this.resizable(document.getElementById('input_t'),13);
        resizable(document.getElementById('input_s1'), 13);
        resizable(document.getElementById('input_s2'), 13);
        resizable(document.getElementById('input_s3'), 13);
      }, 60);
    },
    func_calc_n(state) {
      if (!state.checkEmpty) {
        console.log('===========================func_calc_n===============');
        state.var_n = Math.round(((parseFloat(state.var_l01) / parseFloat(state.var_d)) - 1) * 100) / 100;
        console.log('parseFloat(state.var_l01) = ' + parseFloat(state.var_l01));
        console.log('parseFloat(state.var_d) = ' + parseFloat(state.var_d));
        switch (state.direction) {
          case 'vniz':
            console.log('state.var_n = ' + state.var_n);
            console.log('Зацепы смотрят в одну сторону – округляем n до целого числа витков')
            break;
          case 'back':
            console.log('state.var_n = ' + state.var_n);
            console.log('Зацепы в перепендик плоскостях (90 и 270 градусов) – округляем n до ближайшего значения n,25 или n,75')
            break;
          case 'verh':
            console.log('state.var_n = ' + state.var_n);
            console.log('Зацепы смотрят в противоположные стороны – округляем n до ближайшего значения n,5')
            break;
          case 'front':
            console.log('state.var_n = ' + state.var_n);
            console.log('Зацепы в перепендик плоскостях (90 и 270 градусов) – округляем n до ближайшего значения n,25 или n,75')
            break;
          default:
            alert("Ошибка!");
            break;
        }
      }
    },
    func_calc_s3(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_s3===============');
        console.log('');

        let d_value_list = [];
        for (var j in state.d_values[state.selected - 1]) {
          d_value_list.push(state.d_values[state.selected - 1][j].value);
        }
        // При вводе d ищется ближайшее подходящее значение и его индекс(что даст доступ к v_Newton)
        var getNumber = (arr) =>
          arr.find(it => Math.abs(it - searchNum) === Math.min(...d_value_list.map(it => Math.abs(it - searchNum))));

        var searchNum = state.var_d;
        var get_val = getNumber(d_value_list, searchNum);
        var index = d_value_list.indexOf(get_val);

        var tau_dop_ = parseFloat(state.d_values[state.selected - 1][index].v_Newton);
        console.log("tau_dop_ = " + tau_dop_);

        state.calc_D0 = parseFloat(state.var_Dnar) - parseFloat(state.var_d);

        let var_i_tau = parseFloat(state.calc_D0) / parseFloat(state.var_d);
        let var_k1 = (4 * var_i_tau - 1) / (4 * var_i_tau - 4) + 0.615 / var_i_tau;
        console.log("state.calc_D0 = " + state.calc_D0);
        console.log("var_i_tau = " + var_i_tau);
        console.log("var_k1 = " + var_k1);
        state.var_s3 = Math.round((Math.PI * tau_dop_ * Math.pow(state.calc_D0, 2) * state.var_n / state.calc_G / state.var_d / var_k1) * 100) / 100;
        console.log("state.var_s3 = " + state.var_s3);
      }
    },
    func_calc_s1_s2_s3(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_s1_s2_s3===============');
        console.log('');
        // Расчет s1 s2 s3 f1 f2 f3
        // S1=L1-L0; 
        // S2=L2-L0; 
        // S3=L3-L0
        if (state.var_l1 !== '') {
          state.var_s1 = Math.round((parseFloat(state.var_l1) - parseFloat(state.var_l0)) * 100) / 100;
          console.log('state.var_l1 = ' + state.var_l1);
          console.log('state.var_l0 = ' + state.var_l0);
          console.log('state.var_s1 = ' + state.var_s1);
        } else {
          state.var_s1 = '';
        }
        if (state.var_l2 !== '') {
          // 39. Расчётная величина - Длина пружины между зацепами при нагрузке F2, L2 = L0 + S2[мм]
          // 40 - правильно
          state.var_s2 = Math.round((parseFloat(state.var_l2) - parseFloat(state.var_l0)) * 100) / 100;
          console.log('state.var_s2 = ' + state.var_s2);
        } else {
          state.var_s2 = '';
        }
        // if (state.var_l3 !== '') {
        //   // 40. Расчётная величина - Длина пружины между зацепами при нагрузке F3, L3 = L0 + S3[мм]
        //   // 50 - правильно
        //   state.var_s3 = Math.round((parseFloat(state.var_l3) - parseFloat(state.var_l0)) * 100) / 100;
        //   console.log('state.var_s3 = ' + state.var_s3);
        // }

        // let var_G = state.var_k * this.material_list[this.selected - 1].v_G;

        let d_value_list = [];
        for (var j in state.d_values[state.selected - 1]) {
          d_value_list.push(state.d_values[state.selected - 1][j].value);
        }
        // При вводе d ищется ближайшее подходящее значение и его индекс(что даст доступ к v_Newton)
        var getNumber = (arr) =>
          arr.find(it => Math.abs(it - searchNum) === Math.min(...d_value_list.map(it => Math.abs(it - searchNum))));

        var searchNum = state.var_d;
        var get_val = getNumber(d_value_list, searchNum);
        var index = d_value_list.indexOf(get_val);

        var tau_dop = parseFloat(state.d_values[state.selected - 1][index].v_Newton);
        console.log("tau_dop = " + tau_dop);

        state.calc_D0 = parseFloat(state.var_Dnar) - parseFloat(state.var_d);

        let var_i_tau = parseFloat(state.calc_D0) / parseFloat(state.var_d);
        let var_k1 = (4 * var_i_tau - 1) / (4 * var_i_tau - 4) + 0.615 / var_i_tau;
        console.log("state.calc_D0 = " + state.calc_D0);
        console.log("var_i_tau = " + var_i_tau);
        console.log("var_k1 = " + var_k1);
        state.var_s3 = Math.round((Math.PI * tau_dop * Math.pow(state.calc_D0, 2) * state.var_n / state.calc_G / state.var_d / var_k1) * 100)/100;
        console.log("state.var_s3 = " + state.var_s3);
        // }, 50);
      }
    },
    func_calc_f1_f2_f3(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_f1_f2_f3===============');
        console.log('');
        // Расчет f1 f2 f3
        if (state.var_s1 !== '') {
          // 35. Предварительная нагрузка F1 = S1 * z[Н или Кг в завис.от п .0] 3, 81 - правильно
          state.var_f1 = Math.round((parseFloat(state.var_s1) * parseFloat(state.var_z)) * 100) / 100;
          switch (state.measurement) {
            case 'Newton':
              state.var_f1_view = state.var_f1;
              break;
            case 'kilo':
              state.var_f1_view = Math.round((state.var_f1 * 0.101972) * 100) / 100;
              break;
          }
          console.log('state.var_f1 = ' + state.var_f1);
        } else {
          state.var_f1 = '';
          state.var_f1_view = '';
        }
        if (state.var_s2 !== '') {
          // 36. Рабочая нагрузка F2 = S2 * z[Н или Кг в завис.от п .0] 22, 88 - правильно
          state.var_f2 = Math.round((parseFloat(state.var_s2) * parseFloat(state.var_z)) * 100) / 100;
          switch (state.measurement) {
            case 'Newton':
              state.var_f2_view = state.var_f2;
              break;
            case 'kilo':
              state.var_f2_view = Math.round((state.var_f2 * 0.101972) * 100) / 100;
              break;
          }
          console.log('state.var_f2 = ' + state.var_f2);
        } else {
          state.var_f2 = '';
          state.var_f2_view = '';
        }
        if (state.var_s3 !== '') {
          // 37. Максимальная нагрузка F3 = S3 * z[Н или Кг в завис.от п .0] 41, 95 - правильно
          state.var_f3 = Math.round((parseFloat(state.var_s3) * parseFloat(state.var_z)) * 100) / 100;
          switch (state.measurement) {
            case 'Newton':
              state.var_f3_view = state.var_f3;
              break;
            case 'kilo':
              state.var_f3_view = Math.round((state.var_f3 * 0.101972) * 100) / 100;
              break;
          }
          console.log('state.var_f3 = ' + state.var_f3);
        }
        // }, 50);
      }
    },
    func_calc_l1_l2_l3(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_l1_l2_l3===============');
        console.log('');
        // Расчет l1 l2 l3 f1 f2 f3
        // L1=L0+S1;
        // L2=L0+S2;
        // L3=L0+S3
        if (state.var_s1 !== '') {
          // 38. Расчётная величина - Длина пружины между зацепами при нагрузке F1, L1 = L0 + S1[мм]
          // 30 - правильно
          state.var_l1 = Math.round((parseFloat(state.var_l0) + parseFloat(state.var_s1)) * 100) / 100;
          console.log('state.var_l1 = ' + state.var_l1);
        } else {
          state.var_l1 = '';
        }
        if (state.var_s2 !== '') {
          // 39. Расчётная величина - Длина пружины между зацепами при нагрузке F2, L2 = L0 + S2[мм]
          // 40 - правильно
          state.var_l2 = Math.round((parseFloat(state.var_l0) + parseFloat(state.var_s2)) * 100) / 100;
          console.log('state.var_l2 = ' + state.var_l2);
        } else {
          state.var_l2 = '';
        }
        if (state.var_s3 !== '') {
          // 40. Расчётная величина - Длина пружины между зацепами при нагрузке F3, L3 = L0 + S3[мм]
          // 50 - правильно
          state.var_l3 = Math.round((parseFloat(state.var_l0) + parseFloat(state.var_s3)) * 100) / 100;
          console.log('state.var_l3 = ' + state.var_l3);
        }
        // }, 50);
      }
    },
    func_calc_tau3(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_tau3===============');
        console.log('');
        // 41. Расчётная величина - Максимальные касательные напряжения tau3 = 8 * k1 * F3 * D0 / (пи() * d * d * d), [МПа, если k = 9, 81 или кг / мм2 если k = 1]
        // где переменные i = D0 / d;
        // k1 = (4 * i - 1) / (4 * i - 4) + 0, 615 / i
        // 906, 9 - правильно
        let var_i_tau = parseFloat(state.calc_D0) / parseFloat(state.var_d);
        let var_k1 = (4 * var_i_tau - 1) / (4 * var_i_tau - 4) + 0.615 / var_i_tau;
        let calc_d_3 = Math.pow(state.var_d, 3);
        console.log('state.var_i_tau = ' + var_i_tau);
        console.log('state.var_k1 = ' + var_k1);
        console.log('state.calc_d_3 = ' + calc_d_3);
        state.var_tau3 = Math.round((8 * var_k1 * parseFloat(state.var_f3) * parseFloat(state.calc_D0) / (Math.PI * calc_d_3)) * 10) / 10;
        console.log('state.var_tau3 = ' + state.var_tau3);
        // }, 50);
      }
    },
    func_calc_Dvn(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_Dvn===============');
        console.log('');
        // 29.	Внутренний диаметр зацепа = 6mm
        state.var_Dvn = Math.round(((parseFloat(state.var_Dnar) - parseFloat(state.var_d) * 2) * parseFloat(state.var_n3)) * 100) / 100;
        console.log('state.var_n3 = ' + state.var_n3);
        console.log('state.var_Dvn = ' + state.var_Dvn);
        // }, 50);
      }
    },
    func_calc_Dnar(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_Dnar===============');
        console.log('');
        // 29.	Наружний диаметр зацепа
        state.var_Dnar = Math.round(((parseFloat(state.var_Dvn) / parseFloat(state.var_n3) + parseFloat(state.var_d) * 2)) * 100) / 100;
        state.calc_D0 = parseFloat(state.var_Dnar) - parseFloat(state.var_d);
        console.log('state.var_n3 = ' + state.var_n3);
        console.log('state.var_Dnar = ' + state.var_Dnar);
        // }, 50);
      }
    },
    func_calc_l01(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_l01===============');
        console.log('');
        // 30.	Длина пружины по телу = 16mm
        state.var_l01 = Math.round(((parseFloat(state.var_n) + 1) * parseFloat(state.var_d)) * 100) / 100;
        console.log('state.var_l01 = ' + state.var_l01);
        // }, 50);
      }
    },
    func_calc_l01_1(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_l01_1===============');
        console.log('');
        // 30.	Длина пружины по телу = 16mm
        state.var_l01 = Math.round(((parseFloat(state.var_l0) - (2 * parseFloat(state.var_Dvn) * parseFloat(state.var_p)))) * 100) / 100;
        console.log('state.var_l01 = ' + state.var_l01);
        // }, 50);
      }
    },
    func_calc_l0(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_l0===============');
        console.log('');
        // 31.	Длина пружины между зацепами 12 + 16 = 28mm (ПОКА без Lзам)
        state.var_l0 = Math.round((2 * parseFloat(state.var_Dvn) * parseFloat(state.var_p) + parseFloat(state.var_l01)) * 100) / 100;
        console.log('state.var_l0 = ' + state.var_l0);
        // }, 50);
      }
    },
    func_calc_m_total_m(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_m_total_m===============');
        console.log('');
        // 42. Расчётная величина - Масса пружины m = 2, 512 * D0 * d * d * (n + 2) * r / 1000000[кг]
        // 0, 00229 - правильно
        state.var_m = 2.512 * parseFloat(state.calc_D0) * Math.pow(state.var_d, 2) * (parseFloat(state.var_n) + 2) * parseFloat(state.material_list[state.selected - 1].v_r) / 1000000;
        state.var_m = Math.round(parseFloat(state.var_m) * 10000) / 10000;
        console.log('state.var_m = ' + parseFloat(state.var_m));
        console.log('state.state.material_list[state.selected - 1].v_r = ' + parseFloat(state.material_list[state.selected - 1].v_r));
        // 43. Количество пружин в партии, шт(kol)– 1000 шт
        // 44. Масса партии пружин, кг(m * kol)
        // 2, 29 кг - правильно
        state.var_total_m = parseFloat(state.var_m) * parseFloat(state.kol_pruzhin);
        if (state.var_total_m >= 1) {
          state.var_total_m = Math.round(state.var_total_m * 100) / 100;
        } else {
          state.var_total_m = Math.round(state.var_total_m * 10000) / 10000;
        }
        console.log('state.var_total_m = ' + state.var_total_m);
        // }, 50);
      }
    },
    func_calc_i_a(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_i_a===============');
        console.log('');
        // 32.	Индекс пружины = 7
        state.var_i = Math.round(((parseFloat(state.var_Dnar) - parseFloat(state.var_d)) / parseFloat(state.var_d)) * 100) / 100;
        console.log('state.var_i = ' + state.var_i);
        // 33.	Размер открытой части зацепа а=1,5*d, если i<6; а=2,5*d, если i>=6  =7
        if (state.var_i < 6) {
          state.var_a = Math.round((1.5 * parseFloat(state.var_d)) * 100) / 100;
        } else if (state.var_i >= 6) {
          state.var_a = Math.round((2.5 * parseFloat(state.var_d)) * 100) / 100;
        }
        console.log('state.var_a = ' + state.var_a);
        // }, 50);
      }
    },
    func_calc_z(state) {
      if (!state.checkEmpty) {
        // setTimeout(() => {
        console.log('===========================func_calc_z===============');
        console.log('');
        // 34. Жёсткость пружины z = G * d * d * d * d / (8 * D0 * D0 * D0 * n)[Н / мм или Кг / мм в завис.от п .0]
        // 1, 9067 - правильно
        let calc_d_4 = Math.pow(state.var_d, 4);
        state.calc_D0 = parseFloat(state.var_Dnar) - parseFloat(state.var_d);
        let calc_D0_3 = Math.pow(state.calc_D0, 3);
        state.calc_G = parseFloat(state.var_k) * parseFloat(state.material_list[state.selected - 1].v_G);
        console.log("state.calc_G = " + state.calc_G);
        console.log("state.var_k = " + state.var_k);
        console.log("state.material_list[state.selected - 1].v_G = " + state.material_list[state.selected - 1].v_G);
        state.var_z = state.calc_G * calc_d_4 / (8 * calc_D0_3 * parseFloat(state.var_n));
        console.log('state.calc_G = ' + state.calc_G);
        console.log('state.var_d = ' + state.var_d);
        console.log('calc_d_4 = ' + calc_d_4);
        console.log('calc_D0_3 = ' + calc_D0_3);
        console.log('parseFloat(state.var_n) = ' + parseFloat(state.var_n));
        switch (state.measurement) {
          case 'Newton':
            state.var_z_stiffness = Math.round(state.var_z * 100) / 100 + ' Н/мм';
            break;
          case 'kilo':
            state.var_z_stiffness = Math.round((state.var_z * 0.101972) * 100) / 100 + ' кг/мм';
            break;
        }
        console.log('state.var_z = ' + state.var_z);
        // }, 50);
      }
    },
    func_reCalc(state) {
      setTimeout(() => {
        console.log('===========================func_reCalc===============');
        console.log('');
        console.log('func_reCalc');
        console.log(state.zacepType);
      }, 250);
    },
  },
  actions: {
    func_reCalc(context) {
      context.commit('func_reCalc');
    },
    func_calc_l1_l2_l3(context) {
      context.commit('func_calc_l1_l2_l3');
    },
    mounted_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_Dvn');
      context.commit('func_calc_i_a');
      context.commit('func_calc_l01');
      context.commit('func_calc_l0');
      context.commit('func_calc_z');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    },
    // func_calc_all(context) {
    //   context.commit('func_calc_Dvn');
    //   context.commit('func_calc_i_a');
    //   context.commit('func_calc_Dnar');
    //   context.commit('func_calc_l01');
    //   context.commit('func_calc_l0');
    //   context.commit('func_calc_z');
    //   context.commit('func_calc_s1_s2_s3');
    //   context.commit('func_calc_f1_f2_f3'); //f1 f2 f3 сразу после s1 s2 s3 (ввод L1 L2 L3)
    //   context.commit('func_calc_l1_l2_l3');
    //   context.commit('func_calc_f1_f2_f3'); //f1 f2 f3 сразу после l1 l2 l3 (ввод S1 S2 S3)
    //   context.commit('func_calc_tau3');
    //   context.commit('func_calc_m_total_m');
    // },
    // Материал
    // $store.commit('func_calc_z');$store.commit('func_calc_s1_s2_s3');$store.commit('func_calc_tau3');
    material_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_z');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    },
    input_replace({
      commit
    }) {
      return new Promise((resolve) => {
        commit('func_input_replace')
        resolve()
      })
    },
    turn_number_n_action({
      dispatch,
      commit,
      state
    }) {
      return dispatch('input_replace').then(() => {
        state.vvod_n = true;
        commit('direction');
        commit('func_calc_l01');
        commit('func_calc_l0');
        commit('func_calc_z');
        commit('func_calc_s1_s2_s3');
        commit('func_calc_f1_f2_f3');
        commit('func_calc_l1_l2_l3');
        commit('func_calc_tau3');
        commit('func_calc_m_total_m');
        commit('func_output_replace');
      })
    },
    // turn_number_n_action(context) {
    //   console.log('2var_n = ' + context.state.var_n);
    //   context.commit('func_input_replace');
    //   console.log('3var_n = ' + context.state.var_n);
    //   context.state.vvod_n = true;
    //   context.commit('direction');
    //   console.log('4var_n = ' + context.state.var_n);
    //   context.commit('func_calc_l01');
    //   context.commit('func_calc_l0');
    //   context.commit('func_calc_m_total_m');
    //   context.commit('func_output_replace');
    // },
    kol_pruzhin_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    },
    calc_Newton_action(context) {
      context.commit('func_input_replace');
      context.commit('calc_Newton');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_output_replace');
    },
    calc_kilo_action(context) {
      context.commit('func_input_replace');
      context.commit('calc_kilo');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_output_replace');
    },
    zacepType_action(context) {
      context.commit('func_input_replace');
      context.commit('turnType');
      context.commit('func_calc_Dvn');
      context.commit('func_calc_i_a');
      context.commit('func_calc_l01');
      context.commit('func_calc_l0');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_output_replace');
    },
    input_l_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_tau3');
      context.commit('func_output_replace');
    },
    input_s_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_tau3');
      context.commit('func_output_replace');
    },
    input_l0_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_l01_1');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_output_replace');
      context.commit('func_resize');
    },
    input_l01_action(context) {
      setTimeout(function () {
      context.commit('func_input_replace');
      context.state.vvod_n = true;
        context.commit('func_calc_n');
        if (context.state.var_n > 0) {
          context.commit('direction');
          context.commit('func_calc_l01');
          context.commit('func_calc_l0');
          switch (context.state.usilieSpec) {
            case 'dlinaSpec':
              context.commit('func_calc_z');
              context.commit('func_calc_l1_l2_l3');
              context.commit('func_calc_s1_s2_s3');
              context.commit('func_calc_f1_f2_f3');
              context.commit('func_calc_tau3');
              context.commit('func_output_replace');
              context.commit('func_resize');
              break;
            case 'hodSpec':
              context.commit('func_calc_z');
              context.commit('func_calc_s3');
              context.commit('func_calc_f1_f2_f3');
              context.commit('func_calc_l1_l2_l3');
              context.commit('func_calc_tau3');
              context.commit('func_output_replace');
              context.commit('func_resize');
              break;
            default:
              alert("Ошибка!");
          }
        }
      }, 2000);
      
      

      // context.commit('func_calc_l0');
      // context.commit('func_calc_s1_s2_s3');
      // context.commit('func_calc_f1_f2_f3');
      // context.commit('func_calc_l1_l2_l3');
      // context.commit('func_calc_tau3');
      // context.commit('func_output_replace');
    },
    input_Dvn_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_Dnar');
      context.commit('func_calc_l0');
      context.commit('func_calc_i_a');
      context.commit('func_calc_z');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    },
    input_d_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_Dvn');
      context.commit('func_calc_Dnar');
      context.commit('func_calc_l01');
      context.commit('func_calc_l0');
      context.commit('func_calc_i_a');
      context.commit('func_calc_z');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    },
    input_Dnar_action(context) {
      context.commit('func_input_replace');
      context.commit('func_calc_Dvn');
      context.commit('func_calc_l0');
      context.commit('func_calc_i_a');
      context.commit('func_calc_z');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    },
    direction_action(context) {
      context.commit('func_input_replace');
      context.state.vvod_n = false;
      // context.commit('direction');
      // context.commit('func_calc_l01');
      // context.commit('func_calc_l0');
      // context.commit('func_calc_m_total_m');
      // context.commit('func_output_replace');
      
      context.commit('direction');
      context.commit('func_calc_l01');
      context.commit('func_calc_l0');
      context.commit('func_calc_z');
      context.commit('func_calc_s1_s2_s3');
      context.commit('func_calc_f1_f2_f3');
      context.commit('func_calc_l1_l2_l3');
      context.commit('func_calc_tau3');
      context.commit('func_calc_m_total_m');
      context.commit('func_output_replace');
    }
  },
  modules: {}
})